import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import PropTypes from 'prop-types';

//component ui:
import DatePicker from '../../components/utils/DatePicker';
//material ui:
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Input from '@material-ui/core/Input';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';

//components of grids:
import MaquinaCentros from './maquina_centros';
import MaquinaItv from './maquina_itv';
import MaquinaLicencias from './maquina_licencias';
import MaquinaIncidencias from './maquina_incidencias';
import MaquinaContadores from './maquina_contadores';
import MaquinaActionButtons from './maquina_action_buttons';

//actions:
import { navigate, setSaveState, openDialog } from '../../actions';

import { getData } from '../../dataLib';

//for the select options:
import {
    getMaquinaDetalles,
    modifyFieldDetalleMaquina,
    addNewMaquina,
} from '../../actions/maquina_detalle_actions';
//import { getModelosMaquina } from '../../actions/modelos_maquina_actions';

import * as config from '../../constants/configuration';

const styles = theme => ({
    toolbar: {
        display: 'block',
        minHeight: 112,
        marginBottom: 15,
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    formRight: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 0 5px 20px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    formSelect: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 0 5px 20px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    formComent: {
        display: 'flex',
        justifyContent: 'center',
        margin: '10px 0 5px 25px',
        width: 520,
        minWidth: 120,
    },
    grid: {
        padding: '0 12px',
        width: '100%',
    },
    buttonAtras: {
        margin: '0 0 10px 16px',
        height: 40,
        width: 123,
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    centroSelect: {
        maxWidth: 240,
    },
    modeloSelect: {
        marginRight: 20,
        maxWidth: 240,
    },
    buttonIcon: {
        marginLeft: theme.spacing(2),
        borderRadius: 0,
        border: 'none',
        boxShadow: 'none',
        height: 48,
    },
});

class MaquinaEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: '',
            descr: '',
            matricula: '',
            iModeloMaquina: '',
            modelo: '',
            fechaCompra: null,
            fechaBaja: null,
            regInterno: '',
            comentarios: '',
            regaloDirecto: false,
            activa: false,

            iTipoMaquina: '',
            tipo: '',
            centroId: '',
            centro: '',

            fechaAlta: null,
        };
    }

    componentDidMount() {
        if (!this.props.user && config.AUTH) {
            this.props.navigate(''); //go to home page
            return;
        }

        //if is a new maquina we put the state to empty:
        if (this.props.match.params.id === '-1') {
            getData(
                'VMaquinas/NuevoRegInterno',
                response => {
                    this.props.addNewMaquina(
                        [...this.props.modelosMaquina].sort(
                            this.compareDescr,
                        )[0].id,
                        this.props.centros[0].id,
                        response.data,
                    );
                },
                undefined,
                this.props.user,
            );
        }
        //otherwise, get all its details:
        else this.props.getMaquinaDetalles(this.props.match.params.id);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.detallesmaquina !== this.props.detallesmaquina) {
            //once we get the data:
            this.setState({
                id: this.props.match.params.id
                    ? this.props.match.params.id
                    : -1,
                descr: !this.props.detallesmaquina
                    ? ''
                    : this.props.detallesmaquina.descr,
                matricula: this.props.detallesmaquina
                    ? this.props.detallesmaquina.matricula
                    : '',
                iModeloMaquina: this.props.detallesmaquina
                    ? this.props.detallesmaquina.iModeloMaquina
                    : '',
                modelo: this.props.detallesmaquina
                    ? this.props.detallesmaquina.modelo
                    : [...this.props.modelosMaquina].sort(this.compareDescr)[0]
                        .descr,
                fechaCompra: this.props.detallesmaquina
                    ? this.props.detallesmaquina.fechaCompra
                        ? this.props.detallesmaquina.fechaCompra.slice(0, 10)
                        : ''
                    : '',
                fechaBaja: this.props.detallesmaquina
                    ? !this.props.detallesmaquina.fechaBaja
                        ? ''
                        : this.props.detallesmaquina.fechaBaja.slice(0, 10)
                    : null,
                regInterno: this.props.detallesmaquina
                    ? this.props.detallesmaquina.regInterno
                    : '',
                comentarios: !this.props.detallesmaquina
                    ? ''
                    : this.props.detallesmaquina.comentarios,
                regaloDirecto: this.props.detallesmaquina
                    ? this.props.detallesmaquina.regaloDirecto
                    : false,
                activa: this.props.detallesmaquina
                    ? this.props.detallesmaquina.activa
                    : false,

                iTipoMaquina: this.props.detallesmaquina
                    ? this.props.detallesmaquina.iTipoMaquina
                    : '',
                tipo: this.props.detallesmaquina
                    ? this.props.detallesmaquina.tipo
                    : '',
                centro: this.props.detallesmaquina
                    ? this.props.detallesmaquina.centro
                    : '',
                centroId: this.props.detallesmaquina
                    ? this.props.detallesmaquina.centroId
                    : '',

                fechaAlta: this.props.detallesmaquina
                    ? this.props.detallesmaquina.fechaAlta
                    : '',
            });

            if (prevProps.updated !== this.props.updated && this.props.updated)
                this.props.navigate('mae_maquina');
        }
    }

    //textfield
    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    };
    handleValueChangeDate = (event, field) => {
        //this.setState({ ...this.state, [field]: event });
        this.props.setSaveState(true);
        this.props.modifyFieldDetalleMaquina(field, event);
    };

    //checkbox:
    handleBooleanChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.checked });
    };

    //modelo maquina select:
    handleModeloMaquinaChange = event => {
        const value = parseInt(event.target.value);

        this.setState({
            ...this.state,
            iModeloMaquina: value,
            modelo: this.props.modelosMaquina.find(mm => mm.id === value).descr,
        });
    };

    compareDescr = (a, b) => {
        if (a.descr < b.descr) return -1;
        if (a.descr > b.descr) return 1;
        return 0;
    };

    fillModelosMaquina = () => {
        //poner un SPINNER hasta que se imprima toda la lista (tarda unos 2-3 segs):

        return [...this.props.modelosMaquina]
            .sort(this.compareDescr)
            .map(mm => {
                return (
                    <option key={mm.id} value={mm.id}>
                        {mm.descr}
                    </option>
                );
            });
    };

    onBlur = (event, field) => {
        //const value = event.target.value;

        console.log(field);
        console.log(this.state[field]);

        const value = this.state[field];

        if (this.props.detallesmaquina[field] !== value) {
            this.props.setSaveState(true);
            this.props.modifyFieldDetalleMaquina(field, value);
        }
    };

    onBlurCheckBox = (event, field) => {
        let value = event.target.checked;

        if (value === 'true') value = true;
        else if (value === 'false') value = false;

        this.props.setSaveState(true);
        this.props.modifyFieldDetalleMaquina(field, value);
    };

    goBack = () => {
        if (this.props.saveState.pending) {
            this.props.openDialog(
                'ConfirmationDialog',
                {
                    message:
                        'Existen cambios no guardados. Desea abandonar la sección y perder los cambios?',
                    acceptHandler: () => {
                        this.props.setSaveState(false);
                        this.props.navigate('mae_maquina');
                    },
                },
                'left-drawer-confirmation-message',
                false,
                'sm',
            );
        } else {
            this.props.navigate('mae_maquina');
        }
    };

    render() {
        const { classes } = this.props;

        return this.props.detallesmaquina && this.props.modelosMaquina ? (
            <div>
                <div className={classes.toolbar} />
                <Grid container spacing={24}>
                    <form>
                        {/* <Button className={classes.buttonAtras} variant="contained" color="secondary" onClick={() => this.props.navigate("mae_maquina")}>Atrás</Button> */}
                        <IconButton
                            className={classes.buttonIcon}
                            variant="contained"
                            color="secondary"
                            onClick={this.goBack}
                        >
                            {' '}
                            <Icon>keyboard_backspace</Icon>
                        </IconButton>

                        <div className={classes.containerPair}>
                            <FormControl className={classes.formControl}>
                                <TextField
                                    id={'descr'}
                                    label={'Nombre'}
                                    placeholder={'Nombre'}
                                    autoFocus
                                    value={this.state.descr}
                                    onChange={event =>
                                        this.handleValueChange(event, 'descr')
                                    }
                                    onBlur={event =>
                                        this.onBlur(event, 'descr')
                                    }
                                    onKeyPress={e => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            this.onBlur(e, 'descr');
                                        }
                                    }}
                                />
                            </FormControl>

                            <FormControl className={classes.modeloSelect}>
                                <InputLabel htmlFor="modelomaquina-placeholder">
                                    Modelo de Maquina
                                </InputLabel>
                                <Select
                                    native
                                    value={this.state.iModeloMaquina}
                                    onChange={this.handleModeloMaquinaChange}
                                    onBlur={event =>
                                        this.onBlur(event, 'iModeloMaquina')
                                    }
                                    input={<Input id="input-modelos" />}
                                    style={{ maxHeight: 300 }}
                                    name="modeloMaquina"
                                >
                                    {this.fillModelosMaquina()}
                                </Select>
                            </FormControl>
                            <FormControl className={classes.centroSelect}>
                                <InputLabel htmlFor="input-centros">
                                    Centro
                                </InputLabel>
                                <Select
                                    native
                                    disabled={
                                        this.props.match.params.id !== '-1'
                                    }
                                    value={this.state.centroId}
                                    onChange={event =>
                                        this.handleValueChange(
                                            event,
                                            'centroId',
                                        )
                                    }
                                    onBlur={event =>
                                        this.onBlur(event, 'centroId')
                                    }
                                    input={<Input id="input-centros" />}
                                    name="centroId"
                                >
                                    {this.props.centros.map(centro => {
                                        return (
                                            <option
                                                key={'centro_' + centro.id}
                                                value={centro.id}
                                            >
                                                {centro.centro}
                                            </option>
                                        );
                                    })}
                                </Select>
                            </FormControl>
                        </div>

                        <div className={classes.containerPair}>
                            <FormControl className={classes.formControl}>
                                <TextField
                                    id={'matricula'}
                                    label={'Matricula'}
                                    placeholder={'Matricula'}
                                    value={this.state.matricula}
                                    onChange={event =>
                                        this.handleValueChange(
                                            event,
                                            'matricula',
                                        )
                                    }
                                    onBlur={event =>
                                        this.onBlur(event, 'matricula')
                                    }
                                    onKeyPress={e => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            this.onBlur(e, 'matricula');
                                        }
                                    }}
                                />
                            </FormControl>

                            <FormControl className={classes.formRight}>
                                <TextField
                                    id={'regInterno'}
                                    label={'Reg Interno'}
                                    placeholder={'Reg Interno'}
                                    value={this.state.regInterno}
                                    onChange={event =>
                                        this.handleValueChange(
                                            event,
                                            'regInterno',
                                        )
                                    }
                                    onBlur={event =>
                                        this.onBlur(event, 'regInterno')
                                    }
                                    onKeyPress={e => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            this.onBlur(e, 'regInterno');
                                        }
                                    }}
                                />
                            </FormControl>
                        </div>

                        <div className={classes.containerPair}>
                            <FormControl className={classes.formControl}>
                                <DatePicker
                                    label={'Fecha Compra'}
                                    value={this.state.fechaCompra}
                                    onChange={event => {
                                        if (event && !isNaN(event)) {
                                            const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                            this.handleValueChangeDate(
                                                d.toISOString().slice(0, 10),
                                                'fechaCompra',
                                            )
                                        }
                                    }}
                                    onBlur={event =>
                                        this.onBlur(event, 'fechaCompra')
                                    }
                                    onKeyPress={e => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            this.onBlur(e, 'fechaCompra');
                                        }
                                    }}
                                />
                            </FormControl>

                            {this.props.match.params.id === '-1' ? (
                                <FormControl className={classes.formControl}>
                                    <DatePicker
                                        label={'Fecha Alta'}
                                        value={this.state.fechaAlta}
                                        onChange={event => {
                                            if (event && !isNaN(event)) {
                                                const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                                this.handleValueChangeDate(
                                                    d.toISOString().slice(0, 10),
                                                    'fechaAlta',
                                                )
                                            }

                                        }}
                                        onBlur={event =>
                                            this.onBlur(event, 'fechaAlta')
                                        }
                                        onKeyPress={e => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                this.onBlur(e, 'fechaAlta');
                                            }
                                        }}
                                    />
                                </FormControl>
                            ) : (
                                ''
                            )}

                            <FormControl className={classes.formRight}>
                                <DatePicker
                                    label={'Fecha Baja'}
                                    value={this.state.fechaBaja}
                                    onChange={event => {
                                        if (event && !isNaN(event)) {
                                            const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                            this.handleValueChangeDate(
                                                d.toISOString().slice(0, 10),
                                                'fechaBaja',
                                            )
                                        }
                                        else {
                                            this.handleValueChangeDate(null, 'fechaBaja')
                                        }
                                    }}
                                    onBlur={event =>
                                        this.onBlur(event, 'fechaBaja')
                                    }
                                    onKeyPress={e => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            this.onBlur(e, 'fechaBaja');
                                        }
                                    }}
                                />
                            </FormControl>
                        </div>

                        <div>
                            <FormControl className={classes.formComent}>
                                <TextField
                                    multiline
                                    rows="3"
                                    id={'comentarios'}
                                    label={'Comentarios'}
                                    placeholder={'Comentarios'}
                                    value={this.state.comentarios}
                                    onChange={event =>
                                        this.handleValueChange(
                                            event,
                                            'comentarios',
                                        )
                                    }
                                    onBlur={event =>
                                        this.onBlur(event, 'comentarios')
                                    }
                                />
                            </FormControl>
                        </div>

                        <div
                            className={classes.containerPair}
                            style={{ marginTop: 15 }}
                        >
                            <FormControl className={classes.formControl}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={this.state.activa}
                                            onChange={event =>
                                                this.handleBooleanChange(
                                                    event,
                                                    'activa',
                                                )
                                            }
                                            onBlur={event =>
                                                this.onBlurCheckBox(
                                                    event,
                                                    'activa',
                                                )
                                            }
                                            onKeyPress={e => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    this.onBlur(e);
                                                }
                                            }}
                                            color="primary"
                                        />
                                    }
                                    label="Activa"
                                />
                            </FormControl>

                            <FormControl className={classes.formRight}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={this.state.regaloDirecto}
                                            onChange={event =>
                                                this.handleBooleanChange(
                                                    event,
                                                    'regaloDirecto',
                                                )
                                            }
                                            onBlur={event =>
                                                this.onBlurCheckBox(
                                                    event,
                                                    'regaloDirecto',
                                                )
                                            }
                                            onKeyPress={e => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    this.onBlur(e);
                                                }
                                            }}
                                            color="primary"
                                        />
                                    }
                                    label="Regalo Directo"
                                />
                            </FormControl>
                        </div>
                    </form>

                    <div className={classes.grid}>
                        <MaquinaContadores
                            id={parseInt(this.props.match.params.id)}
                        />
                    </div>
                    <div className={classes.grid}>
                        <MaquinaIncidencias
                            id={parseInt(this.props.match.params.id)}
                        />
                    </div>
                    <div className={classes.grid}>
                        <MaquinaLicencias
                            id={parseInt(this.props.match.params.id)}
                        />
                    </div>
                    <div className={classes.grid}>
                        <MaquinaItv id={parseInt(this.props.match.params.id)} />
                    </div>
                    <div className={classes.grid}>
                        <MaquinaCentros
                            id={parseInt(this.props.match.params.id)}
                        />
                    </div>
                    <div className={classes.grid}>
                        <MaquinaActionButtons
                            id={parseInt(this.props.match.params.id)}
                            backHandler={this.goBack}
                        />
                    </div>
                </Grid>
            </div>
        ) : (
            ''
        );
    }
}

MaquinaEdit.propTypes = {
    //state
    user: PropTypes.object.isRequired,
    detallesmaquina: PropTypes.object,
    updated: PropTypes.bool.isRequired,
    tiposMaquina: PropTypes.object.isRequired,
    modelosMaquina: PropTypes.array.isRequired,
    centros: PropTypes.array.isRequired,
    //dispatch
    navigate: PropTypes.func.isRequired,
    getMaquinaDetalles: PropTypes.func.isRequired,
    modifyFieldDetalleMaquina: PropTypes.func.isRequired,
    addNewMaquina: PropTypes.func.isRequired,
    getModelosMaquina: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        detallesmaquina: state.maquinaDetalle.maquinadetalles,
        updated: state.maquinaDetalle.updated,
        tiposMaquina: state.tiposMaquina,
        modelosMaquina: state.modelosMaquina.modelosmaquina,
        centros: state.centros.centros,
        saveState: state.saveState,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            navigate,
            getMaquinaDetalles,
            modifyFieldDetalleMaquina,
            addNewMaquina,
            //getModelosMaquina,
            setSaveState,
            openDialog,
        },
        dispatch,
    );
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(withStyles(styles, { withTheme: true })(MaquinaEdit)));
